import {
  Box,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";

import { AccountInfoData } from "./AccountInfo";
import { MeteringByDetectorData } from "./MeteringInfo";

export interface ActivityByDetectorTableProps {
  data: MeteringByDetectorData[] | undefined;
  loadingInfo: boolean;
}

export function ActivityByDetectorTable(props: ActivityByDetectorTableProps) {
  const { data, loadingInfo } = props;

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Function to handle page change
  const handlePageChange = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  // Function to handle rows per page change
  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (loadingInfo) {
    return <Skeleton variant="rounded" height={250} data-testid="loading-skeleton" />;
  }

  if (data && data.length === 0 && !loadingInfo) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "250px", fontSize: "20px" }}>
        There is no data to show
      </Box>
    );
  }

  const tableCellBaseStyle = {
    fontWeight: "500",
    letterSpacing: "-0.5px",
    textAlign: "right",
    width: "30%",
  };

  const tableHeadCellBaseStyle = {
    ...tableCellBaseStyle,
    padding: 0,
    fontSize: "12px",
    lineHeight: "14px",
    paddingBottom: "10px",
  };

  const tableBodyCellBaseStyle = {
    ...tableCellBaseStyle,
    padding: "5px 0px",
    fontSize: "20px",
    lineHeight: "24px",
  };

  return (
    <Stack sx={{ alignItems: "center", gap: "10px" }}>
      <AccountInfoData text="Activity by detector" />

      <TableContainer>
        <Table aria-label="activity-by-detector">
          <TableHead>
            <TableRow sx={{ textTransform: "uppercase" }}>
              <TableCell sx={[tableHeadCellBaseStyle, { textAlign: "left", width: "40%" }]}>
                Detector <br /> name
              </TableCell>
              <TableCell sx={tableHeadCellBaseStyle}>
                Cloud <br /> queries
              </TableCell>
              <TableCell sx={tableHeadCellBaseStyle}>
                Groundlight <br /> Cloud Labeler Answers
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((detector) => (
              <TableRow key={detector.detector_id} sx={{ textTransform: "uppercase" }}>
                <TableCell sx={[tableBodyCellBaseStyle, { textAlign: "left", width: "40%" }]}>
                  {detector.detector_name}
                </TableCell>
                <TableCell sx={tableBodyCellBaseStyle}>{detector.image_queries}</TableCell>
                <TableCell sx={tableBodyCellBaseStyle}>{detector.escalations}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={data?.length || 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
        sx={{ alignSelf: "flex-end" }}
      />
    </Stack>
  );
}
